import { render, staticRenderFns } from "./ListContactPage.vue?vue&type=template&id=030fe037&"
import script from "./ListContactPage.vue?vue&type=script&lang=js&"
export * from "./ListContactPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports